import React from 'react';
import { Typography, List, Flex, theme } from 'antd';
import { DesktopOutlined, MobileOutlined } from '@ant-design/icons';

type NewClearPartialCacheModalProps = {
  urlsResult: any;
  clearUrlCacheResult: any;
};

export const NewClearPartialCacheModal: React.FC<NewClearPartialCacheModalProps> = ({
  urlsResult,
  clearUrlCacheResult,
}) => {
  const limit = 10;
  const { token } = theme.useToken();

  const urls = urlsResult.data?.urls || [];
  const urlsCount = urlsResult.data?.count || 0;

  const getTitle = () => {
    if (clearUrlCacheResult.isLoading) return 'Clearing cache for URLs, please wait...';
    if (urlsResult.isFetching) return 'Retrieving URLs, please wait...';

    return `This will clear cache for ${urlsCount} URL${urlsCount == 1 ? '' : 's'} ${
      urlsCount > limit ? ', For example:' : ''
    }`;
  };

  return (
    <>
      <div style={{ margin: '0 auto' }}>
        <Typography.Paragraph>{getTitle()}</Typography.Paragraph>
      </div>
      <List
        size="small"
        dataSource={urls}
        renderItem={(item: any) => (
          <List.Item>
            <Flex align="center" gap={8}>
              {item.adaptiveType === 'mobile' ? (
                <MobileOutlined style={{ color: token.colorTextSecondary }} />
              ) : (
                <DesktopOutlined style={{ color: token.colorTextSecondary }} />
              )}
              <Typography.Text>{item.url}</Typography.Text>
            </Flex>
          </List.Item>
        )}
      />
    </>
  );
};
